const ajax_wrappers = document.querySelectorAll('.ajax-posts')

ajax_wrappers.forEach(wrapper => {
    const data_container = wrapper.querySelector('.ajax-content')
    const initial_query = JSON.parse(wrapper.dataset.query)
    const filters = wrapper.querySelectorAll('.ajax-filter')
    const filter_drawer = wrapper.querySelector('.filter-drawer')
    const filter_drawer_toggle = wrapper.querySelector('.filter-drawer-toggle')
    const filter_headings = wrapper.querySelectorAll('.filter-heading')

    let selected_taxonomies = {}
    let selected_authors = []
    let busy = false

    const scroll_to_posts = () => {
        const rect = wrapper.getBoundingClientRect()
        window.scrollTo({top: rect.top + window.scrollY - 150, behavior: 'smooth'})
    }
    const bind_pagination = () => {
        const pagination_container = wrapper.querySelector('.ajax-pagination')
        if (pagination_container) {
            const pagination_links = pagination_container.querySelectorAll('a')
            pagination_links.forEach(link => {
                link.addEventListener('click', async (e) => {
                    e.preventDefault()
                    const href = link.getAttribute('href')
                    const query = JSON.parse(wrapper.dataset.query)
                    query.paged = page_from_url(href)

                    await get_posts(query)
                    scroll_to_posts()
                    set_url_from_query(query)
                })
            })
        }
    }

    const toggle_filter_element = (el) => {
        el.classList.toggle('active')

        if (el.dataset.taxonomy && el.dataset.term) {
            const taxonomy = el.dataset.taxonomy
            const term = parseInt(el.dataset.term)
            const tax_filters = selected_taxonomies?.[taxonomy] || {terms: [], relation: 'OR'}
            const found_filter = tax_filters.terms.findIndex(f => f === term)

            if (found_filter === -1) {
                tax_filters.terms.push(term)
            } else {
                tax_filters.terms.splice(found_filter, 1)
            }
            selected_taxonomies[taxonomy] = tax_filters
        }


        if (el.dataset.user) {
            const author = parseInt(el.dataset.user)
            const user_filters = selected_authors
            const found_author = user_filters.findIndex(a => a === author)

            if (found_author !== -1) {
                user_filters.splice(found_author, 1)
            } else {
                user_filters.push(author)
            }
            selected_authors = user_filters

        }
    }
    const set_active_filters_from_query = (query) => {

        filters.forEach(filter => {
            filter.classList.remove('active')
        })

        const find_tax_filter_element = (item) => {
            return Array.from(filters).find(f => f.dataset.taxonomy === item.taxonomy && parseInt(f.dataset.term) === item.terms)
        }

        const find_author_filter_element = (user) => {
            return Array.from(filters).find(f => parseInt(f.dataset.user) === user)
        }

        const active_elements = []
        if (query.tax_query) {

            query.tax_query.forEach(item => {
                if (item.taxonomy) {
                    const el = find_tax_filter_element(item)
                    if (el) {
                        active_elements.push(el)
                    }
                } else {
                    for (const [key, i ] of Object.entries(item)) {
                        if (i.taxonomy) {
                            const el = find_tax_filter_element(i)
                            if (el) {
                                active_elements.push(el)
                            }
                        }
                    }
                }
            })

        }

        if (query.author__in) {
            query.author__in.forEach(author => {
                const el = find_author_filter_element(author)
                if (el) {
                    active_elements.push(el)
                }
            })
        }

        active_elements.forEach(el => {
            toggle_filter_element(el)
        })
    }
    const set_url_from_query = (query) => {
        const url = new URL(wrapper.dataset.blogUrl)

        const taxonomies = []

        if (query.tax_query) {
            query.tax_query.forEach(item => {
                if (item.taxonomy) {
                    taxonomies.push({
                        taxonomy: item.taxonomy,
                        terms: [item.terms]
                    })
                } else {
                    for (const [key, i ] of Object.entries(item)) {
                        if (i.taxonomy) {
                            const existing = taxonomies.find(p => p.taxonomy === i.taxonomy )
                            if (!existing) {
                                taxonomies.push({
                                    taxonomy: i.taxonomy,
                                    terms: [i.terms]
                                })
                            } else {
                                existing.terms = [...existing.terms, i.terms]
                            }
                        }
                    }
                }
            })
        }

        taxonomies.forEach(param => {
            url.searchParams.set(param.taxonomy, param.terms.join(','))
        })

        if (query.author__in && query.author__in.length > 0) {
            url.searchParams.set('a', query.author__in.join(','))
        }

        if (query.paged && query.paged > 1) {
            url.searchParams.set('p', query.paged)
        }
        url.search = decodeURIComponent(url.search)
        history.replaceState(query, "", url.toString());
    }
    const get_posts = async (query) => {
        busy = true
        wrapper.classList.add('busy')
        const form_data = new FormData();
        form_data.append('action', 'kp_get_posts');
        form_data.append('query', JSON.stringify(query));
        form_data.append('base_url', wrapper.dataset.baseUrl);

        const response = await fetch(window.kpa.ajax_url, {method: "POST", body: form_data})
        const post_data = await response.json()

        data_container.innerHTML = post_data.content
        wrapper.dataset.query = JSON.stringify(post_data.query)

        bind_pagination()
        busy = false
        wrapper.classList.remove('busy')
    }

    bind_pagination()
    set_active_filters_from_query(initial_query)

    filter_drawer_toggle.addEventListener('click', e => {
        e.preventDefault()
        filter_drawer_toggle.classList.toggle('active')

        if (filter_drawer_toggle.classList.contains('active')) {
            filter_drawer.style.maxHeight = `${filter_drawer.scrollHeight}px`
        } else {
            filter_drawer.style.maxHeight = 0;
        }
    })

    filter_headings.forEach(heading => {
        heading.addEventListener('click', e => {
            heading.classList.toggle('active')
            const list = heading.nextElementSibling
            if (heading.classList.contains('active')) {
                list.style.maxHeight = `${list.scrollHeight}px`
            } else {
                list.style.maxHeight = 0;
            }
            filter_drawer.style.maxHeight = `100%`

            setTimeout(() => {
                filter_drawer.style.maxHeight = `${filter_drawer.scrollHeight}px`
            }, 300)
        })
    })

    filters.forEach(filter => {
        filter.addEventListener('click', async (e) => {
            e.preventDefault()
            if (busy) {
                return;
            }

            const query = JSON.parse(wrapper.dataset.query)
            query.paged = 1

            toggle_filter_element(filter)

            const tax_query = []
            for (const tax in selected_taxonomies) {
                const filter = selected_taxonomies[tax]
                const selected_terms = filter.terms
                if (selected_terms.length > 1) {
                    tax_query.push({
                        relation: filter.relation,
                        ...selected_terms.map(term => ({taxonomy: tax, terms: term}))
                    })
                } else if (selected_terms.length === 1) {
                    tax_query.push({taxonomy: tax, terms: selected_terms[0]})
                }
            }
            query.tax_query = tax_query

            if (selected_authors.length === 0) {
                query.author__in = []
            } else {
                query.author__in = selected_authors
            }

            await get_posts(query)
            set_url_from_query(query)
        })
    })


    // addEventListener("popstate", async (event) => {
    //     const query = event.state ?? initial_query
    //     await get_posts(query)
    //     console.log(query)
    //     set_active_filters_from_query()
    // });



})

const page_from_url = (url) => {
    const match = url.match(/(?:\/page\/|[?&]paged=)([1-9]\d*)/)
    if (match) {
        return Number(match[1]);
    }
    return 1;
}